import React from 'react'

import Layout from '../components/layout'
import Seo from '../components/seo'

const SecondPage = () => (
  <Layout>
    <Seo title="Page two" />
    <h1>Components</h1>
    <p>Welcome to the components page.</p>
  </Layout>
)

export default SecondPage
